/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_H2 as H2,
  rec_JSXRuntime as JSXRuntime,
  rec_PuestoOrganigrama as PuestoOrganigrama,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_c4 as c4,
  rec_s4 as s4,
  rec_z2 as z2,
} from "../../runtime/index.jsx";
export function EscaleraOrganigrama(e) {
  let t = (0, ReactCompiler.c)(28),
    { arbol: n, onAbrir: r, enfocar: i } = e,
    { raices: a, porId: o } = n,
    s;
  t[0] === a ? (s = t[1]) : ((s = () => z2(a, 2)), (t[0] = a), (t[1] = s));
  let [c, l] = (0, React.useState)(s),
    [u, f] = (0, React.useState)(null),
    p = (0, React.useRef)(null),
    [m, h] = (0, React.useState)(null);
  if (i && i !== m) {
    h(i);
    let e = new Set(c);
    for (let t of H2(o, i.id)) e.delete(t);
    (l(e), f(i.id));
  }
  let _;
  t[2] === u
    ? (_ = t[3])
    : ((_ = () => {
        u &&
          p.current?.querySelector(`[data-puesto="${u}"]`)?.scrollIntoView?.({
            block: `center`,
            behavior: `smooth`,
          });
      }),
      (t[2] = u),
      (t[3] = _));
  let v;
  (t[4] !== c || t[5] !== u
    ? ((v = [u, c]), (t[4] = c), (t[5] = u), (t[6] = v))
    : (v = t[6]),
    (0, React.useEffect)(_, v));
  let y;
  t[7] === o
    ? (y = t[8])
    : ((y = [...o.values()].filter(c4).map(s4)), (t[7] = o), (t[8] = y));
  let b = y,
    x;
  t[9] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((x = function (e) {
        l((t) => {
          let n = new Set(t);
          return (n.has(e) ? n.delete(e) : n.add(e), n);
        });
      }),
      (t[9] = x))
    : (x = t[9]);
  let S = x;
  if (!a.length) {
    let e;
    return (
      t[10] === Symbol.for(`react.memo_cache_sentinel`)
        ? ((e = (
            <p
              className={`rounded-2xl border border-(--border) p-4 text-sm text-(--text)`}
              children={`No hay puestos para mostrar con este filtro.`}
            />
          )),
          (t[10] = e))
        : (e = t[10]),
      e
    );
  }
  let C;
  t[11] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((C = (
        <button
          type={`button`}
          onClick={() => l(new Set())}
          className={`min-h-11 rounded-full border border-(--border) px-4 text-(--text-h) hover:bg-(--accent-bg)`}
          children={`Abrir todo`}
        />
      )),
      (t[11] = C))
    : (C = t[11]);
  let w;
  t[12] === b
    ? (w = t[13])
    : ((w = (
        <div
          className={`flex flex-wrap gap-2 text-sm`}
          children={[
            C,
            <button
              type={`button`}
              onClick={() => l(new Set(b))}
              className={`min-h-11 rounded-full border border-(--border) px-4 text-(--text-h) hover:bg-(--accent-bg)`}
              children={`Cerrar todo`}
            />,
          ]}
        />
      )),
      (t[12] = b),
      (t[13] = w));
  let T;
  if (t[14] !== c || t[15] !== r || t[16] !== a || t[17] !== u) {
    let e;
    (t[19] !== c || t[20] !== r || t[21] !== u
      ? ((e = (e) => (
          <PuestoOrganigrama
            key={e.fila.id}
            nodo={e}
            cerrados={c}
            onAlternar={S}
            onAbrir={r}
            resaltado={u}
          />
        )),
        (t[19] = c),
        (t[20] = r),
        (t[21] = u),
        (t[22] = e))
      : (e = t[22]),
      (T = a.map(e)),
      (t[14] = c),
      (t[15] = r),
      (t[16] = a),
      (t[17] = u),
      (t[18] = T));
  } else T = t[18];
  let E;
  t[23] === T
    ? (E = t[24])
    : ((E = (
        <ul
          role={`tree`}
          aria-label={`Escalera del organigrama`}
          className={`flex flex-col gap-2`}
          children={T}
        />
      )),
      (t[23] = T),
      (t[24] = E));
  let D;
  return (
    t[25] !== w || t[26] !== E
      ? ((D = (
          <div ref={p} className={`flex flex-col gap-3`} children={[w, E]} />
        )),
        (t[25] = w),
        (t[26] = E),
        (t[27] = D))
      : (D = t[27]),
    D
  );
}
